import { ShieldCheckIcon, HeartIcon, HomeModernIcon } from '@heroicons/react/24/outline';

const WhyItMattersSection = () => {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-b from-background via-secondary/20 to-background">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Lead with empowerment, not fear */}
          <div className="text-center mb-16">
            <p className="text-lg text-primary font-bold mb-4 uppercase tracking-wider">
              Why SeniorThrive
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">
              Stay independent. Stay confident.
            </h2>
            <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Living well at home starts with small, everyday choices, and the right tools
              to help you make them with confidence.
            </p>
          </div>

          {/* The pivot, what we do about it */}
          <div className="bg-gradient-to-br from-primary/5 to-accent/10 rounded-lg p-8 md:p-12 shadow-floating mb-12">
            <h3 className="text-2xl md:text-3xl font-bold text-foreground text-center mb-4">
              SeniorThrive puts you in the driver's seat.
            </h3>
            <p className="text-lg md:text-xl text-muted-foreground text-center leading-relaxed max-w-3xl mx-auto">
              Every tool is designed around one idea: when you can see what's going well
              and what needs attention, you make better decisions for your home and health.
            </p>
          </div>

          {/* How the tools map to prevention */}
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4">
                <HomeModernIcon className="w-7 h-7 text-primary" />
              </div>
              <h4 className="text-lg font-bold text-foreground mb-2">
                Make your home work for you
              </h4>
              <p className="text-muted-foreground leading-relaxed">
                Room-by-room guides help you set up each space for comfort, safety, and ease, at your own pace.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4">
                <HeartIcon className="w-7 h-7 text-primary" />
              </div>
              <h4 className="text-lg font-bold text-foreground mb-2">
                Know how you're doing, day to day
              </h4>
              <p className="text-muted-foreground leading-relaxed">
                Simple wellness check-ins and vitals tracking keep you informed and in tune with your health.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4">
                <ShieldCheckIcon className="w-7 h-7 text-primary" />
              </div>
              <h4 className="text-lg font-bold text-foreground mb-2">
                Build confidence, not worry
              </h4>
              <p className="text-muted-foreground leading-relaxed">
                Your ThriveScore grows as you take action, a reflection of the great choices you're already making.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyItMattersSection;
